/* ============================================================
   WANKUL — Barre de progression des paliers cadeaux (affichage seul)
   Les cadeaux sont ajoutés par l'app ; ce script n'ajoute ni ne retire rien.
   Montant pris en compte : sous-total du panier après réductions
   (les cadeaux offerts sont à 0 € et ne comptent donc pas).
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.WK_GIFT_BAR;
  if (!CFG || !CFG.enabled || !CFG.tiers || !CFG.tiers.length) return;

  var TIERS = CFG.tiers.slice().sort(function (a, b) { return a.threshold - b.threshold; });
  var LAST = TIERS[TIERS.length - 1];
  var lastCart = null;
  var timer = null;
  var paused = false;

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v.replace(',00', '') + ' €';
  }

  function total(cart) {
    return cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
  }

  function barHTML(cart) {
    var t = total(cart);
    var pct = Math.min(100, (t / LAST.threshold) * 100);
    var next = null;
    for (var i = 0; i < TIERS.length; i++) { if (t < TIERS[i].threshold) { next = TIERS[i]; break; } }

    var msg = next
      ? 'Plus que <strong>' + money(next.threshold - t) + '</strong> pour débloquer : <strong>' + next.label + '</strong>'
      : '<strong>Tous les cadeaux sont débloqués !</strong>';

    var marks = TIERS.map(function (tier) {
      var on = t >= tier.threshold;
      return '<li class="wk-gift-bar__mark' + (on ? ' is-on' : '') + '" style="left:' + (tier.threshold / LAST.threshold * 100) + '%">' +
        '<span class="wk-gift-bar__dot"></span><span class="wk-gift-bar__amount">' + money(tier.threshold) + '</span></li>';
    }).join('');

    return '<p class="wk-gift-bar__msg">🎁 ' + msg + '</p>' +
      '<div class="wk-gift-bar__track"><span class="wk-gift-bar__fill" style="width:' + pct + '%"></span>' +
      '<ul class="wk-gift-bar__marks">' + marks + '</ul></div>';
  }

  function render(cart) {
    if (!cart) return;
    paused = true;
    document.querySelectorAll('.js-cart-content').forEach(function (content) {
      var bar = content.querySelector('.wk-gift-bar');
      if (!cart.item_count) { if (bar) bar.remove(); return; }
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'wk-gift-bar';
        var header = content.querySelector('.drawer__header');
        if (header && header.parentNode === content) header.insertAdjacentElement('afterend', bar);
        else content.insertBefore(bar, content.firstChild);
      }
      var html = barHTML(cart);
      if (bar.innerHTML !== html) bar.innerHTML = html;
    });
    setTimeout(function () { paused = false; }, 0);
  }

  // Compteur du panier dans l'en-tête
  function updateCount(cart) {
    document.querySelectorAll('.js-header-cart-item-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    document.querySelectorAll('.js-header-cart-item-count-wrapper').forEach(function (w) {
      if (cart.item_count > 0) w.classList.remove('is-hidden');
    });
  }

  function refresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { lastCart = cart; render(cart); updateCount(cart); })
        .catch(function () {});
    }, typeof delay === 'number' ? delay : 300);
  }

  function start() {
    // Mises à jour du panier par le thème
    var tc = window.themeCore;
    if (tc && tc.EventBus) tc.EventBus.listen('cart:updated', function () { refresh(); });

    // Mises à jour par les apps (ajout de cadeaux, upsell…)
    if (window.fetch && !window.fetch.__wkBar) {
      var orig = window.fetch;
      var wrapped = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = orig.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { refresh(); }, function () {});
        return p;
      };
      wrapped.__wkBar = true;
      window.fetch = wrapped;
    }

    // Apps qui passent par XMLHttpRequest
    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__wkBar) {
      var open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        if (/\/cart\/(add|change|update|clear)/.test(url || '')) {
          this.addEventListener('load', function () { refresh(); });
        }
        return open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.__wkBar = true;
    }

    // Cadeaux ajoutés par BOGOS : on rafraîchit le panier du thème (sans recharger la page)
    var themeTimer = null;
    function refreshThemeCart() {
      clearTimeout(themeTimer);
      themeTimer = setTimeout(function () {
        var core = window.themeCore;
        if (core && core.EventBus) core.EventBus.emit('cart:refresh');
        refresh(150);
      }, 250);
    }
    function openSideCart() {
      var core = window.themeCore;
      var hasDrawer = document.querySelector('[data-section-modification="drawer"]');
      if (core && core.EventBus && hasDrawer) core.EventBus.emit('cart:drawer:refresh-and-open');
      else if (core && core.EventBus) core.EventBus.emit('cart:refresh');
      refresh(150);
    }
    ['fg-gifts:added', 'bogos:items-added', 'fg-cart:auto-updated', 'fg-cart:end-process', 'bogos:cart-change'].forEach(function (name) {
      window.addEventListener(name, refreshThemeCart);
      document.addEventListener(name, refreshThemeCart);
    });
    // Sécurité : clic sur un bouton « Ajouter / Choisir » du popup BOGOS
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.bogos-gift-item-add-btn')) {
        // Après le choix de la taille : on rafraîchit et on ouvre le panier latéral
        setTimeout(openSideCart, 700);
        setTimeout(refreshThemeCart, 1600);
      }
    }, true);

    // Le thème remplace le contenu du panier : on remet la barre
    new MutationObserver(function () {
      if (paused || !lastCart) return;
      clearTimeout(start.t);
      start.t = setTimeout(function () { render(lastCart); }, 60);
    }).observe(document.body, { childList: true, subtree: true });

    refresh(0);
  }

  var started = false;
  function boot() { if (started) return; started = true; start(); }
  if (window.themeCore && window.themeCore.loaded) boot();
  else {
    document.addEventListener('theme:all:loaded', boot, { once: true });
    window.addEventListener('load', function () { setTimeout(boot, 1500); });
  }
})();
